import { makeModule } from '@codium/codium-vue'

export const storeModule = makeModule('screens', {
  parent: 'lists'
})
